import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject,of  } from 'rxjs';
import { tap } from 'rxjs/operators';
import { authBackendEndPointToken } from '../app.config';
import { catchError, map } from 'rxjs/operators';
import { DisableCache } from '../loading.interceptor';
import { HttpContext } from '@angular/common/http';

export interface Event {
  id: string; // Changed from _id to id (Guid)
  title: string;
  description?: string;
  start: string;
  end: string;
  type: string;
  platform: string;
  meetingUrl?: string; // Now a string representation of Uri
  image?: string;
  participants: string[]; // No longer optional
  organizationId?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt?: string;
  isActive: boolean;
  location?: string;
  maxAttendees?: number;
  tags: string[]; // No longer optional
}

export interface EventResponse<T = Event[]> {
  success: boolean;
  message: string;
  data: T;
}

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private backendUrl = inject(authBackendEndPointToken);
  private readonly URL = `${this.backendUrl}/api/publicevents`;

  // Subject to notify components when events change
  private eventsChangedSubject = new Subject<void>();
  public eventsChanged$ = this.eventsChangedSubject.asObservable();

  constructor(private http: HttpClient) {}

  getEvents(): Observable<EventResponse<Event[]>> {
    return this.http.get<EventResponse<Event[]>>(`${this.URL}`);
  }

  getEventById(id: string): Observable<EventResponse<Event>> {
    return this.http.get<EventResponse<Event>>(`${this.URL}/${id}`);
  }

  getEventsByParticipant(participants: string[]): Observable<EventResponse<Event[]>> {
    return this.http.post<EventResponse<Event[]>>(`${this.URL}/by-participants`, { participants });
  }
getVisibleEvents(): Observable<EventResponse<Event[]>> {
  return this.http.get<EventResponse<Event[]>>(
    `${this.URL}/visible`,
    {
      context: new HttpContext().set(DisableCache, true) // ✅ disable cache
    }
  ).pipe(
      catchError((error: any) => {
        console.error('Error fetching visible events:', error);
        return of({
          success: false,
          message: 'Error fetching visible events',
          data: []
        });
      })
    );
}
  getEventsByParticipants(roles: string[]): Observable<EventResponse<Event[]>> {
    let params = new HttpParams();
    if (roles && !roles.includes('system admin')) {
      roles.forEach(role => {
        params = params.append('roles', role);
      });
    }
    return this.http.get<EventResponse<Event[]>>(`${this.URL}/participant/one`, { params });
  }

  createEvent(eventData: Partial<Event>): Observable<EventResponse<Event>> {
    return this.http.post<EventResponse<Event>>(`${this.URL}`, eventData).pipe(
      tap(() => this.eventsChangedSubject.next())
    );
  }

  updateEvent(id: string, eventData: Partial<Event>): Observable<EventResponse<Event>> {
    return this.http.put<EventResponse<Event>>(`${this.URL}/${id}`, eventData).pipe(
      tap(() => this.eventsChangedSubject.next())
    );
  }

  deleteEvent(id: string): Observable<EventResponse<null>> {
    return this.http.delete<EventResponse<null>>(`${this.URL}/${id}`).pipe(
      tap(() => this.eventsChangedSubject.next())
    );
  }
}